import { render, staticRenderFns } from "./Ownership.vue?vue&type=template&id=b9bca926"
import script from "./Ownership.vue?vue&type=script&lang=js"
export * from "./Ownership.vue?vue&type=script&lang=js"
import style0 from "./Ownership.vue?vue&type=style&index=0&id=b9bca926&prod&lang=scss"
import style1 from "./Ownership.vue?vue&type=style&index=1&id=b9bca926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports